import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import React, { FC, useState, useEffect } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { Helmet } from "react-helmet";
import { ourFleetsApi } from "services/apiServices";
import SectionSubHero from "components/SectionSubHero";
import LoadingSpinner from "components/LoadingSpinner";

export interface ListingTransportPageProps {
  className?: string;
}

const ListingTransportPage: FC<ListingTransportPageProps> = ({ className = "" }) => {
  const [fleetsData, setFleetsData] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  const fetchFleetsData = async () => {
    try {
      setLoading(true);
      const response = await ourFleetsApi()

      if (response.data) {
        let fleetstempData: any = [];
        if (response.data.response === "success") {
          console.log("Fleets Data", response.data)

          response.data.fleets.map(async (item: any, key: number) => {
            fleetstempData[key] = {
              id: item.id,
              title: item.brand,
              model: item.model,
              featuredImage: item.image ?? (item.exterior_images ? JSON.parse(item.exterior_images)[0] : ''),
              seats: item.pax_count ?? item.seating_capacity,
              year: item.year?? 'N/A'
            }
            // console.log("restdata",fleetstempData)
            setFleetsData(fleetstempData)
          })


        }
      }
    } catch (error) {

    }finally{
      setLoading(false);
    }

  }

  useEffect(() => {
    fetchFleetsData()
  }, []);

  return (
    <div
      className={`nc-ListingTransportPage relative overflow-hidden ${className}`}
      data-nc-id="ListingTransportPage"
    >
      <Helmet>
        <title>FLEETS | EUROPE TOURS & TRAVELS</title>
      </Helmet>
      <BgGlassmorphism />

      {/* <SectionHero /> */}
      <SectionSubHero
        title="Our Fleets"
        pillTitle="Ride Options"
        bgClass="dashboard-fleet-bg"
        description="A modern, well-maintained fleet offering comfortable, reliable transportation for every travel need."
        className="pl-6 pt-10 lg:pt-10 lg:pb-10 mb-16"
      />

      <div className="container relative mt-4 md:mt-0 lg:mt-0 xl:mt-0" style={{ minHeight: "300px" }}>
        {/* SECTION */}
        {/* <SectionGridFilterCard className="pb-24  lg:pt-32 lg:pb-16" /> */}
        {loading && (
                  <LoadingSpinner text="Loading Fleets..." />
                )}

        {fleetsData.length > 0 && !loading &&
          <SectionGridFilterCard
            data={fleetsData}
            className="pb-24 lg:pt-32 lg:pb-16" />
        }


      </div>
    </div>
  );
};

export default ListingTransportPage;
